import aptCircle from 'assets/logos/apt-circle.svg'
import aptSquare from 'assets/logos/apt-square.svg'
import usdcCircle from 'assets/logos/usdc-circle.svg'
import thAPTLogo from 'assets/logos/thAPT.svg'
import sthAPTLogo from 'assets/logos/sthAPT.png'
import amAPTLogo from 'assets/logos/amAPT.png'
import stAPTLogo from 'assets/logos/stAPT.png'
import thlLogo from 'assets/logos/thl.svg'
import usdcWHLogo from 'assets/logos/usdcWH.svg'
import usdtLZLogo from 'assets/logos/usdtLZ.svg'
import usdtWHLogo from 'assets/logos/usdtWH.svg'
import wethLZLogo from 'assets/logos/wethLZ.svg'
import wethWHLogo from 'assets/logos/wethWH.svg'
import movementUSDTLogo from 'assets/logos/movement-usdt.svg'
import movementUSDCLogo from 'assets/logos/movement-usdc.svg'
import movementWETHLogo from 'assets/logos/movement-weth.svg'
import movementEZETHLogo from 'assets/logos/movement-ezeth.svg'
import movementMBTCLogo from 'assets/logos/movement-mbtc.svg'
import movementSTBTCLogo from 'assets/logos/movement-stbtc.svg'
import movementWBTCLogo from 'assets/logos/movement-wbtc.svg'
import movementLogo from 'assets/logos/movement.svg'
import stMoveLogo from 'assets/logos/stMOVE.svg'
import movementRSETHLogo from 'assets/logos/movement-rseth.svg'
import movementWEETHLogo from 'assets/logos/movement-weeth.svg'
import movementLBTCLogo from 'assets/logos/movement-lbtc.png'
import movementUSDALogo from 'assets/logos/movement-usda.svg'
import movementSUSDALogo from 'assets/logos/movement-susda.svg'
import movementSavUSDLogo from 'assets/logos/movement-savusd.svg'

export type ChainId = string
export interface ChainMeta {
  chainID: string
  logoURL: string
  name: string
  description: string
}

export interface TokenMeta {
  chainID: ChainId
  logo: string
  ticker: string
  name: string
  description: string
  projectURL: string
  displayName: string
  discontinued: boolean
  borrowDisabled: boolean
}

export interface ChainMetaMap {
  [key: ChainId]: ChainMeta
}

export interface TokenMetaMap {
  [key: string]: TokenMeta
}

export const DEFAULT_CHAIN: ChainMeta = {
  chainID: '',
  logoURL: '',
  name: '',
  description: ''
}

export const DEFAULT_TOKEN: TokenMeta = {
  chainID: '',
  logo: '',
  ticker: '',
  name: '',
  description: '',
  projectURL: '',
  displayName: '',
  discontinued: false,
  borrowDisabled: false
}

//chains
export const CHAIN_APTOS = 'Aptos'
//logos
export const aptosLogo = aptCircle
export const aptosChainLogo = aptSquare
export const usdcLogo = usdcCircle
//tokens
const APTOS = 'aptos'
const APT_USDC = 'usdc'
export const MOVEMENT_USDT_ASSET_NAME = 'movement-usdt'
export const MOVEMENT_USDC_ASSET_NAME = 'movement-usdc'
export const MOVEMENT_WETH_ASSET_NAME = 'movement-weth'
export const MOVEMENT_EZETH_ASSET_NAME = 'movement-ezeth'
export const MOVEMENT_MBTC_ASSET_NAME = 'movement-mbtc'
export const MOVEMENT_STBTC_ASSET_NAME = 'movement-stbtc'
export const MOVEMENT_LBTC_ASSET_NAME = 'movement-lbtc'
export const MOVEMENT_WBTC_ASSET_NAME = 'movement-wbtc'
export const MOVE_NAME = 'movement-move-fa'
export const MOVE_LEGACY_COIN_NAME = 'movement-move'
const THAPT = 'thapt'
const STH_APT = 'sthapt'
const AM_APT = 'amapt'
const STAKED_APT = 'stapt'
const THALA = 'thl'
const WETH_WH = 'wethwh'
const WETH_LZ = 'weth'
const EZETH = 'ezeth'
const USDT_LZ = 'usdtlz'
const USDC_WH = 'usdcwh'
const USDT_WH = 'usdtwh'
export const STAKED_MOVMENT_NAME = 'movement-staked-move'
export const MOVEMENT_RSETH_ASSET_NAME = 'movement-rseth'
export const MOVEMENT_WEETH_ASSET_NAME = 'movement-weeth'
export const MOVEMENT_USDA_ASSET_NAME = 'movement-usda'
export const MOVEMENT_SUSDA_ASSET_NAME = 'movement-susda'
export const MOVEMENT_SAVUSD_ASSET_NAME = 'movement-savusd'
export const MOVEMENT_USDCX_ASSET_NAME = 'movement-usdcx'

export interface MintMap {
  [key: string]: number
}

//map chain ids to chain meta
export const chains: ChainMetaMap = {
  [CHAIN_APTOS]: {
    name: 'Aptos',
    chainID: CHAIN_APTOS,
    logoURL: movementLogo,
    description: 'Aptos'
  }
}

//token meta objects
export const aptos: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: APTOS,
  ticker: 'APT',
  description: '',
  logo: aptosLogo,
  projectURL: '',
  displayName: 'Aptos',
  discontinued: false,
  borrowDisabled: false
}

export const apt_usdc: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: APT_USDC,
  ticker: 'zUSDC',
  description: '',
  logo: usdcLogo,
  projectURL: '',
  displayName: 'USD Coin (LayerZero)',
  discontinued: false,
  borrowDisabled: false
}

export const MovementUSDTMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_USDT_ASSET_NAME,
  ticker: 'USDT.e',
  description: '',
  logo: movementUSDTLogo,
  projectURL: '',
  displayName: 'USDT.e',
  discontinued: false,
  borrowDisabled: false
}

export const MovementUSDCMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_USDC_ASSET_NAME,
  ticker: 'USDC.e',
  description: '',
  logo: movementUSDCLogo,
  projectURL: '',
  displayName: 'USDC.e',
  discontinued: false,
  borrowDisabled: false
}

export const MovementWETHMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_WETH_ASSET_NAME,
  ticker: 'WETH.e',
  description: '',
  logo: movementWETHLogo,
  projectURL: '',
  displayName: 'WETH.e',
  discontinued: false,
  borrowDisabled: false
}

export const MovementEZETHMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_EZETH_ASSET_NAME,
  ticker: 'EZETH',
  description: '',
  logo: movementEZETHLogo,
  projectURL: '',
  displayName: 'Renzo ezETH',
  discontinued: false,
  borrowDisabled: false
}

export const MovementRSETHMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_RSETH_ASSET_NAME,
  ticker: 'RSETH',
  description: '',
  logo: movementRSETHLogo,
  projectURL: '',
  displayName: 'RSETH',
  discontinued: false,
  borrowDisabled: false
}

export const MovementWEETHMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_WEETH_ASSET_NAME,
  ticker: 'WEETH',
  description: '',
  logo: movementWEETHLogo,
  projectURL: '',
  displayName: 'WEETH',
  discontinued: false,
  borrowDisabled: false
}

export const MovementMBTCMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_MBTC_ASSET_NAME,
  ticker: 'MBTC',
  description: '',
  logo: movementMBTCLogo,
  projectURL: '',
  displayName: 'mBTC',
  discontinued: false,
  borrowDisabled: false
}

export const MovementSTBTCMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_STBTC_ASSET_NAME,
  ticker: 'STBTC',
  description: '',
  logo: movementSTBTCLogo,
  projectURL: '',
  displayName: 'stBTC',
  discontinued: true,
  borrowDisabled: false
}

export const MovementLBTCMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_LBTC_ASSET_NAME,
  ticker: 'LBTC',
  description: '',
  logo: movementLBTCLogo,
  projectURL: '',
  displayName: 'LBTC',
  discontinued: true,
  borrowDisabled: false
}

export const MovementUSDAMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_USDA_ASSET_NAME,
  ticker: 'USDa',
  description: '',
  logo: movementUSDALogo,
  projectURL: '',
  displayName: 'USDa',
  discontinued: false,
  borrowDisabled: false
}

export const MovementSUSDAMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_SUSDA_ASSET_NAME,
  ticker: 'sUSDa',
  description: '',
  logo: movementSUSDALogo,
  projectURL: '',
  displayName: 'sUSDa',
  discontinued: false,
  borrowDisabled: true
}

export const MovementSavUSDMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_SAVUSD_ASSET_NAME,
  ticker: 'savUSD',
  description: '',
  logo: movementSavUSDLogo,
  projectURL: '',
  displayName: 'savUSD',
  discontinued: false,
  borrowDisabled: false
}

export const MovementUSDCXMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_USDCX_ASSET_NAME,
  ticker: 'USDCx',
  description: '',
  logo: movementUSDCLogo,
  projectURL: '',
  displayName: 'USDCx',
  discontinued: false,
  borrowDisabled: false
}

export const MovementWBTCMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVEMENT_WBTC_ASSET_NAME,
  ticker: 'WBTC.e',
  description: '',
  logo: movementWBTCLogo,
  projectURL: '',
  displayName: 'WBTC.e',
  discontinued: false,
  borrowDisabled: false
}

export const MoveMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVE_NAME,
  ticker: 'MOVE',
  description: '',
  logo: movementLogo,
  projectURL: '',
  displayName: 'MOVE',
  discontinued: false,
  borrowDisabled: false
}

export const MoveLegacyCoinMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: MOVE_LEGACY_COIN_NAME,
  ticker: 'MOVE (Legacy Coin)',
  description: '',
  logo: movementLogo,
  projectURL: '',
  displayName: 'MOVE Legacy Coin',
  discontinued: true,
  borrowDisabled: false
}

export const StakedMoveMeta: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: STAKED_MOVMENT_NAME,
  ticker: 'stMOVE',
  description: '',
  logo: stMoveLogo,
  projectURL: '',
  displayName: 'Staked Movement',
  discontinued: false,
  borrowDisabled: false
}

export const thAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: THAPT,
  ticker: 'thAPT',
  description: '',
  logo: thAPTLogo,
  projectURL: '',
  displayName: 'Thala APT',
  discontinued: false,
  borrowDisabled: false
}

export const sthAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: STH_APT,
  ticker: 'sthAPT',
  description: '',
  logo: sthAPTLogo,
  projectURL: '',
  displayName: 'Staked Thala APT',
  discontinued: false,
  borrowDisabled: false
}

export const amAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: AM_APT,
  ticker: 'amAPT',
  description: '',
  logo: amAPTLogo,
  projectURL: '',
  displayName: 'Amnis APT',
  discontinued: false,
  borrowDisabled: false
}

export const stakedAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: STAKED_APT,
  ticker: 'stAPT',
  description: '',
  logo: stAPTLogo,
  projectURL: '',
  displayName: 'Staked Amnis APT',
  discontinued: false,
  borrowDisabled: false
}

export const thala: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: THALA,
  ticker: 'THL',
  description: '',
  logo: thlLogo,
  projectURL: '',
  displayName: 'Thala',
  discontinued: false,
  borrowDisabled: false
}

export const wrappedEthWh: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: WETH_WH,
  ticker: 'whWETH',
  description: '',
  logo: wethWHLogo,
  projectURL: '',
  displayName: 'Wrapped Ethereum (Wormhole)',
  discontinued: false,
  borrowDisabled: false
}

export const wrappedEthLZ: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: WETH_LZ,
  ticker: 'zWETH',
  description: '',
  logo: wethLZLogo,
  projectURL: '',
  displayName: 'Wrapped Ethereum (LayerZero)',
  discontinued: false,
  borrowDisabled: false
}

export const usdtLZ: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: USDT_LZ,
  ticker: 'zUSDT',
  description: '',
  logo: usdtLZLogo,
  projectURL: '',
  displayName: 'USD Tether (LayerZero)',
  discontinued: false,
  borrowDisabled: false
}

export const usdcWH: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: USDC_WH,
  ticker: 'whUSDC',
  description: '',
  logo: usdcWHLogo,
  projectURL: '',
  displayName: 'USD Coin (Wormhole)',
  discontinued: false,
  borrowDisabled: false
}

export const usdtWH: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: USDT_WH,
  ticker: 'whUSDT',
  description: '',
  logo: usdtWHLogo,
  projectURL: '',
  displayName: 'USD Tether (Wormhole)',
  discontinued: false,
  borrowDisabled: false
}

export const tokenMetaMap: TokenMetaMap = {
  [MOVE_NAME]: MoveMeta,
  [MOVE_LEGACY_COIN_NAME]: MoveLegacyCoinMeta,
  [MOVEMENT_USDCX_ASSET_NAME]: MovementUSDCXMeta,
  [MOVEMENT_USDC_ASSET_NAME]: MovementUSDCMeta,
  [MOVEMENT_USDT_ASSET_NAME]: MovementUSDTMeta,
  [MOVEMENT_USDA_ASSET_NAME]: MovementUSDAMeta,
  [MOVEMENT_SUSDA_ASSET_NAME]: MovementSUSDAMeta,
  [MOVEMENT_SAVUSD_ASSET_NAME]: MovementSavUSDMeta,
  [MOVEMENT_WETH_ASSET_NAME]: MovementWETHMeta,
  [MOVEMENT_EZETH_ASSET_NAME]: MovementEZETHMeta,
  [MOVEMENT_RSETH_ASSET_NAME]: MovementRSETHMeta,
  [MOVEMENT_WEETH_ASSET_NAME]: MovementWEETHMeta,
  [MOVEMENT_MBTC_ASSET_NAME]: MovementMBTCMeta,
  [MOVEMENT_STBTC_ASSET_NAME]: MovementSTBTCMeta,
  [MOVEMENT_LBTC_ASSET_NAME]: MovementLBTCMeta,
  [MOVEMENT_WBTC_ASSET_NAME]: MovementWBTCMeta,
  [STAKED_MOVMENT_NAME]: StakedMoveMeta
}

export const DUST_LIMIT = 0.00000001
